import { render, staticRenderFns } from "./user-verify.html?vue&type=template&id=53aa7c9b&scoped=true&"
import script from "./user-verify.js?vue&type=script&lang=js&"
export * from "./user-verify.js?vue&type=script&lang=js&"
import style0 from "./user-verify.css?vue&type=style&index=0&id=53aa7c9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53aa7c9b",
  null
  
)

export default component.exports